function factory($q, localStorage) {

    let cachedLastVehicle;
    const key = "cars.vdp.views";

    function getStats() {
        try {
            return JSON.parse(localStorage.getItem(key)) || {};
        } catch (e) {
            return {};
        }
    }

    function getStat(listingId) {
        return getStats()[listingId] || {views: 0, firstTime: Date.now(), firstVisit: Date.now()};
    }

    function getStatPublic(listingId) {
        return $q(function (resolve) {
            return resolve(getStat(listingId));
        });
    }

    function setStat(listingId, stat) {
        let stats = getStats();
        stats[listingId] = stat;
        localStorage.setItem(key, JSON.stringify(stats));
    }

    function trackLead(listingId, emailAddress) {

        // We may want to move this to the backend
        // and save it so I'm going to force the api
        // to be async.
        return $q(function (resolve) {

            let stat = getStat(listingId);

            stat.lastLead = Date.now();
            stat.leadSubmitted = true;
            stat.emailAddress = emailAddress;

            setStat(listingId, stat);
            resolve(stat);
        });


    }

    return {
        trackLead,
        getStat: getStatPublic
    };
}

factory.$inject = ['$q', 'localStorageService'];

export default factory;
